import { render, staticRenderFns } from "./SpouseView.vue?vue&type=template&id=415a5f9b&scoped=true"
import script from "./SpouseView.vue?vue&type=script&lang=js"
export * from "./SpouseView.vue?vue&type=script&lang=js"
import style0 from "./SpouseView.vue?vue&type=style&index=0&id=415a5f9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415a5f9b",
  null
  
)

export default component.exports